export function isIE() {
    return /MSIE|Trident/.test(window.navigator.userAgent);
}



// WEBPACK FOOTER //
// ./utilities/detectIE.js